/**
 * @pp/ui
 * pingpong前端公共UI库
 * suliyu
 * 2017年10月20日15:03:53
 */
import ppui from '@pp/ui'
import '@pp/ui/dist/styles/ppui.css' // UI库的CSS
import Vue from 'vue'
Vue.use(ppui)

export default {
  name: 'ppui'
}
